import type { InternalAxiosRequestConfig } from 'axios';

export type MockResponse = {
  status: number;
  data: unknown;
  statusText?: string;
  headers?: Record<string, string>;
};

export type MockHandler = (
  config: InternalAxiosRequestConfig,
) => MockResponse | Promise<MockResponse>;

const registry = new Map<string, MockHandler>();

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

export function registerMock(method: HttpMethod, urlPattern: string, handler: MockHandler): void {
  registry.set(`${method.toUpperCase()}:${normalizePath(urlPattern)}`, handler);
}

export function matchMock(config: InternalAxiosRequestConfig): MockHandler | undefined {
  const method = (config.method ?? 'GET').toUpperCase();
  const path = stripQuery(config.url ?? '');
  return registry.get(`${method}:${normalizePath(path)}`);
}

export function envKey(config: InternalAxiosRequestConfig): string {
  const method = (config.method ?? 'GET').toUpperCase();
  const path = stripQuery(config.url ?? '');
  return `VITE_MOCK_${(method + path).replace(/[^A-Z0-9]/gi, '_').toUpperCase()}`;
}

export function clearMocks(): void {
  registry.clear();
}

export function listMocks(): string[] {
  return [...registry.keys()];
}

function normalizePath(path: string): string {
  if (!path) return '/';
  const noQuery = stripQuery(path);
  return noQuery.startsWith('/') ? noQuery : `/${noQuery}`;
}

function stripQuery(url: string): string {
  const i = url.indexOf('?');
  return i === -1 ? url : url.slice(0, i);
}
